/** @format */

import { useSearchParams } from "react-router-dom";
import Logout from "./Logout";
import { BBLogin } from "./bbOauth/BBLogin";
import HwbLogin from "./hwbAuth/HwbLogin";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";

const Login = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectUri = searchParams.get("redirect_uri") || "";
    const loginService = searchParams.get("service") || "";
    redirectUri && localStorage.setItem("redirect_uri", redirectUri);

    window.location.href =
      loginService === "hwb" ? `/auth/hwblogin` : `/auth/bblogin`;
  }, [searchParams]);

  return (
    <div className="d-flex justify-content-center m-2">
      <Spinner />
    </div>
  );
};

const authRoutes = [
  {
    path: "bblogin",
    element: <BBLogin />,
  },
  {
    path: `hwblogin`,
    element: <HwbLogin />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
];

export default authRoutes;
